var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticStyle:{"background-color":"black"}},[_c('InformationView'),_c('SimulatorTop'),_c('FooterView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }